import { Injectable } from '@angular/core';
import { LoggerService } from '../logger.service';
import { StorageFilesystemService } from './storage-filesystem.service';
import { StorageMemoryService } from './storage-memory.service';
import { StorageStreamingService } from './storage-streaming.service';
import { BrowserSupportService } from '../browser-support.service';
import { IStorageMethod, ITransferItemDownload } from 'src/sync';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storage: IStorageMethod;
  public maxsize: number;

  constructor(
    private browser: BrowserSupportService,
    private log: LoggerService,
    private filesystemService: StorageFilesystemService,
    private memoryService: StorageMemoryService,
    private streamingService: StorageStreamingService,
  ) {}

  public async prepare(): Promise<void> {
    this.log.info('Preparing storage service');
    if (this.storage) {
      this.log.info('Storage is set');
      return;
    }
    const method = this.browser.getFileStorageMethod();
    switch (method) {
      case 'filesystem':
        try {
          this.log.info('TRANSER: testing filesystem');
          await this.filesystemService.test();
          this.log.info(`TRANSFER STORAGE: 'filesystem'`);
          this.storage = this.filesystemService;
          this.maxsize = this.filesystemService.maxsize;
        } catch (err) {
          this.log.info('TRANSFER STORAGE: memory-filesystemfail');
          this.log.warn('Detected chrome incognito, falling back to memory');
          this.log.warn(err);
          this.storage = this.memoryService;
          this.maxsize = this.memoryService.maxsize;
        }
        break;
      case 'memory':
      default:
        this.storage = this.memoryService;
        this.maxsize = this.memoryService.maxsize;
        this.log.info(`TRANSFER STORAGE: 'memory'`);
        break;
    }
    this.log.info('TRANSFER SAVE: ' + this.browser.getFileSaveMethod());
    this.log.info('storage init completed');
  }

  public getMemoryStorage(): IStorageMethod {
    return this.memoryService;
  }
  /** A handle on the item is the outcome of the capability decision already made under user activation. */
  public getDefaultStorage(tItem?: ITransferItemDownload): IStorageMethod {
    if (tItem?.streamingHandle) {
      return this.streamingService;
    }
    return this.storage;
  }
}
